<section class="setup-parameter page-padding">
    <div class="setup-parameter__container header">
      <h1 class="header__title">{{ 'BASE_DATA.SETUP_PARAMETER_TITLE' | translate }}</h1>
      <section class="filters">
        <div class="form-group text-search p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            id="textSearch"
            type="text"
            class="search-bar"
            pInputText
            [(ngModel)]="externalSetupParameterKindId"
            [placeholder]="'SETUP_PARAMETER_SCREEN.SEARCH_TEXT' | translate"
            (input)="onFilterChange()"
          />
        </div>
        <div class="form-control">
          <lib-button [label]="'SETUP_PARAMETER_SCREEN.RESET'" (clicked)="resetFilters()"></lib-button>
        </div>
        &nbsp;
        <div class="form-control">
          <lib-button [label]="'SETUP_PARAMETER_SCREEN.RELOAD_DATA'" (clicked)="reloadData()"></lib-button>
        </div>
      </section>
    </div>
   
    <div *ngIf="(setupParameterQuery.isLoading$ | async) === false; else loading">
      <app-edit-setup-parameter
        [setupParameters$]="setupParameterQuery.setupParameterList$"
        (updateSetupParameterEvent)="updateEditedSetupParameters()"
        (formValidityChange)="onFormValidityChange($event)"
      ></app-edit-setup-parameter>
    </div>
  </section>
  
  <ng-template #loading>
    <lib-loading-indicator></lib-loading-indicator>
  </ng-template>
  
  <footer class="setup-parameter__footer p-grid p-nogutter">
    <div *ngIf="enableSetupParameter$ | async; else editMode">
      <div class="setup-parameter__footer__leftcorner-wrapper">
        <lib-button
          (clicked)="editAll()"
          [label]="'SETUP_PARAMETER_SCREEN.EDIT_SETUP_PARAMETER' | translate"
          [typeClass]="'button--primary'"
          [sizeClass]="'button--small'"
        ></lib-button>
      </div>
    </div>
  </footer>
  
  <ng-template #editMode>
    <div class="setup-parameter__footer__leftcorner-wrapper">
      <lib-button
        class="setup-parameter__footer--margin-right"
        (clicked)="cancel()"
        [label]="'SETUP_PARAMETER_SCREEN.CANCEL' | translate"
        [typeClass]="'button--secondary'"
        [sizeClass]="'button--small'"
        [loadingTopic]="LOADING_TOPIC_SAVESETUPPARAMETER"
      ></lib-button>
      <lib-button
        (clicked)="save()"
        [label]="'SETUP_PARAMETER_SCREEN.SAVE' | translate"
        [typeClass]="'button--primary'"
        [sizeClass]="'button--small'"
        [loadingTopic]="LOADING_TOPIC_SAVESETUPPARAMETER"
        [disabled]="!isFormValid"
      ></lib-button>
    </div>
  </ng-template>
  